import type { KnownSearchParams } from '../../page'
import {
  COINS_OG_PAGE_SIZE,
  COINS_PAGE_SIZE,
  type CoinTab,
  coinTabValues,
  defaultCoinTab,
  getAllAssetsTab,
  getCoinTabs,
  getTokenizedStocksTab,
} from './configs'

export function normalizeSearchParams(
  searchParams: KnownSearchParams,
  isOGPrice?: boolean,
  options?: { defaultTabValue?: CoinTab },
) {
  const { page, tab } = searchParams

  const pageSize = isOGPrice ? COINS_OG_PAGE_SIZE : COINS_PAGE_SIZE
  const mainTabs = getCoinTabs(pageSize)
  const allTabs = [...mainTabs, getTokenizedStocksTab(), getAllAssetsTab(pageSize)]

  const fallbackTab = options?.defaultTabValue
    ? (allTabs.find(t => t.value === options.defaultTabValue) ?? defaultCoinTab)
    : defaultCoinTab

  const currentPage = page && Number.isSafeInteger(Number(page)) ? Number(page) : 1

  const currentCoinTab =
    tab && coinTabValues.includes(tab as CoinTab)
      ? (allTabs.find(o => o.value === tab) ?? fallbackTab)
      : fallbackTab

  return {
    currentPage,
    currentCoinTab,
  }
}
